import { actionsStyles as quickOrderActionStyle } from "@insite/content-library/Widgets/QuickOrder/QuickOrderActions";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

quickOrderActionStyle.wrapper = {
    ...quickOrderActionStyle.wrapper,
    css: css`
        ${quickOrderActionStyle.wrapper?.css}

        ${mediaQueriesBP.minMD} {
            margin-bottom: 1rem;
        }
    `,
};

quickOrderActionStyle.addToListButton = {
    ...quickOrderActionStyle.addToListButton,
    variant: "secondary",
};
